import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../store/hooks';

import { activeCategorySlice, darkmodeslice, fontsizeslice } from '../store/navigationSlice';  
import { loadStoreSettingSlice } from '../store/staticSettingSlice';  

import fetchData from 'Utilis/request';
import { Appstack } from './AppRoutes';
import useGoogleAuth from 'components/useGoogleAuth';
import { useMobilePlatform } from "../Utilis/device";
import { detectPlatform } from 'store/getPlatformDevice';
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const Navigator = ()=> {
  const location = useLocation();  
  const dispatch = useAppDispatch();
 const platform = useMobilePlatform();  
const sliceCategoryNavigationIndex = useAppSelector((state:any) => state.categoryNavigation.currentIndex);
//   this fakeid used only for rendering 
const sliceFakeid = useAppSelector((state:any) => state.categoryNavigation.fakeid);
 const darkmode = useAppSelector((state:any) => state.categoryNavigation.darkmode); 
 const fontsize = useAppSelector((state:any) => state.categoryNavigation.fontsize); 
 const activecategory = useAppSelector((state:any) => state.categoryNavigation.activecategory); 
 
    const [mainmenu, setMainmenu] = useState<any[]>([]);  
    const [activeCategory, setActiveCategory] = useState<string>('');
    const [fontSize, setFontSize] = useState<string>(
        localStorage.getItem('fontSize') || 'medium'
    );
    const [darkMode, setDarkMode] = useState<boolean>(() => {
        const saved = localStorage.getItem('darkMode');
        return saved === 'true';
    });
    // const hasDetailPage = location.pathname.includes('/news/');
    // const hasGalleryDetailPage = location.pathname.includes('/photos/');
  useGoogleAuth();
    // common api for store 
    const loadStoreSetting = async () => {
 const response = await fetchData.getResult(`${API_BASE_URL}appsetting.php`);
      if(response){
         const filteredMenu = response?.menu.filter((item: any) => item.status === "1");
          dispatch(loadStoreSettingSlice(response));
              setMainmenu(filteredMenu);
      }
    }

 useEffect(() => {                            // react to changes
    dispatch(detectPlatform(platform));    
  }, [platform, dispatch]);


     useEffect(() => {
      loadStoreSetting()
        const savedDarkMode = localStorage.getItem('darkMode');        
        const savedFontSize = localStorage.getItem('fontSize');
        const savedCategory = localStorage.getItem('activeCategory');
        if (savedDarkMode) setDarkMode(savedDarkMode === 'true');
        if (savedFontSize) setFontSize(savedFontSize);
        if (savedCategory) setActiveCategory(savedCategory);
        if(savedCategory && location.pathname === "/"){
          dispatch(activeCategorySlice(savedCategory));
        }
    }, []);

     useEffect(() => {
          localStorage.setItem('darkMode', darkMode.toString());
          localStorage.setItem('fontSize', fontSize);
          if(darkmode !== null){
            localStorage.setItem('darkMode', darkmode);
            } else {
            dispatch(darkmodeslice(darkMode))
           }
          if(fontsize !== null){
            localStorage.setItem('fontSize', fontsize);
           } else {
            dispatch(fontsizeslice(fontSize))
          }        
    }, [darkMode, fontSize, darkmode, fontsize]);


    useEffect(() => {
            if(activecategory)localStorage.setItem('activeCategory', activecategory);
            if(activecategory)handleCategoryChange(activecategory);        
    }, [activeCategory, activecategory]);



    const navigateCategory = (direction: number) => {
        const currentIndex = mainmenu.findIndex(
            item => (item.id === activeCategory) && (item.status === "1") ||
                (activeCategory === 'homepage' && !item.id)
        );
          // console.log(currentIndex,  "currentIndex innter test")
        if (currentIndex === -1) return;

        let newIndex = currentIndex + direction;
        
        // Boundary checks
        newIndex = Math.max(0, Math.min(newIndex, mainmenu.length - 1));
        
        const nextCategory = mainmenu[newIndex];
        
        if (nextCategory) {          
            handleCategoryChange(nextCategory?.id || null);
        }
    };
  


    useEffect(()=>{ 
      if(Array.isArray(mainmenu)) {
        navigateCategory(sliceCategoryNavigationIndex);       
      }
    },[sliceFakeid, mainmenu])

     const handleCategoryChange = (category: string) => {
        setActiveCategory(category); 
         dispatch(activeCategorySlice(category))
        // Find the category config
        const categoryConfig = mainmenu.find(
            item => item.id === category
        );

        if (!categoryConfig) return;

        // Update document title for better UX
        document.title = categoryConfig.title 
            ? `${categoryConfig.title} - Bharat24Live` 
            : "Bharat24Live";
    };

  return (
    <Appstack/>
  )
}
export default Navigator